// Original of a mail in a dialog, and attachment downloads (spec 6.2a). The API needs a bearer token, so both are
// fetched here; the HTML goes into a sandboxed iframe (no scripts, no same origin, no remote resources).
import { ApiError } from "../api";
import { S } from "../state";
import { esc, fmtDT, toast } from "../util";

const FRAME_HEAD = `<meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; style-src 'unsafe-inline'">
<base target="_blank"><style>html{color-scheme:light}body{margin:16px;font:14px/1.5 system-ui,sans-serif;color:#13202B;background:#fff;overflow-wrap:anywhere}img{max-width:100%;height:auto}table{max-width:100%}</style>`;

function dialog(): HTMLDialogElement {
  let d = document.querySelector<HTMLDialogElement>("dialog#original");
  if (!d) {
    d = document.createElement("dialog");
    d.id = "original";
    d.className = "orig";
    d.addEventListener("click", (e) => {
      if (e.target === d || (e.target as HTMLElement).closest("[data-close-original]")) d!.close();
    });
    document.body.append(d);
  }
  return d;
}

export async function showOriginal(mailId: string): Promise<void> {
  const d = dialog();
  d.innerHTML = `<div class="orig-h"><b>Original wird geladen …</b><button class="xbtn" data-close-original aria-label="Schließen">×</button></div>`;
  d.showModal();
  try {
    const o = await S.api.original(mailId);
    d.innerHTML = `<div class="orig-h">
        <div class="orig-meta"><b>${esc(o.subject ?? "(ohne Betreff)")}</b>
          <span>Von ${esc(o.from ?? "–")}</span><span>An ${esc(o.to ?? "–")}${o.cc ? ` · Cc ${esc(o.cc)}` : ""}</span><span class="mono">${fmtDT(o.date)}</span></div>
        <button class="xbtn" data-close-original aria-label="Schließen">×</button></div>
      <iframe class="orig-frame" title="Original der Mail" sandbox="allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer"></iframe>
      <p class="orig-note">Externe Bilder sind ausgeblendet, damit der Absender nicht erfährt, dass die Mail geöffnet wurde.</p>`;
    d.querySelector<HTMLIFrameElement>("iframe")!.srcdoc = `<!doctype html><html><head>${FRAME_HEAD}</head><body>${o.html}</body></html>`;
  } catch (err) {
    d.innerHTML = `<div class="orig-h"><b>${esc(err instanceof ApiError ? err.message : "Das Original konnte nicht geladen werden.")}</b><button class="xbtn" data-close-original aria-label="Schließen">×</button></div>`;
  }
}

export async function downloadAttachment(id: string, filename: string): Promise<void> {
  try {
    const blob = await S.api.attachment(id);
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: filename });
    document.body.append(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (err) {
    toast(err instanceof ApiError ? err.message : "Der Anhang konnte nicht geladen werden.");
  }
}
